// /**
//  * Application configuration
//  * Centralized configuration for environment variables and settings
//  * 
//  * IMPORTANT: Make sure to create a .env.local file with all required environment variables.
//  * See README.md for the complete list of required variables.
//  */

// import { validateEnvironment, isDevelopment, isProduction } from './envValidation'
// import { validateDatabaseSchema } from './dbValidation'

// // Validate environment variables on module load
// const envValidation = validateEnvironment()

// if (!envValidation.isValid) {
//   if (isProduction()) {
//     console.error('❌ Environment validation failed:')
//     envValidation.missing.forEach(key => console.error(`  Missing: ${key}`))
//     envValidation.warnings.forEach(warning => console.warn(`  Warning: ${warning}`))
//     throw new Error('Environment validation failed in production. Check your environment variables.')
//   } else {
//     console.warn('⚠️  Environment validation failed (development mode):')
//     envValidation.missing.forEach(key => console.warn(`  Missing: ${key}`))
//     envValidation.warnings.forEach(warning => console.warn(`  Warning: ${warning}`))
//     console.warn('💡 Create .env.local file with required variables to fix this')
//   }
// } else {
//   console.log('✅ Environment validation passed')
//   if (envValidation.warnings.length > 0) {
//     console.warn('⚠️  Environment warnings:')
//     envValidation.warnings.forEach(warning => console.warn(`  ${warning}`))
//   }
// }

// export const config = {
//   // Site URLs
//   site: {
//     url:
//       isDevelopment()
//         ? "http://localhost:3000"
//         : process.env.NEXT_PUBLIC_SITE_URL ||
//           (process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : "") ||
//           process.env.NEXT_PUBLIC_VERCEL_URL ||
//           "https://landlordnoagent.vercel.app",
//     authUrl: "/auth",
//     dashboardUrl: "/dashboard",
//     adminUrl: "/admin/dashboard",
//   },


//   // API configuration
//   api: {
//     baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5001/api',
//     timeout: 10000,
//     retries: 3,
//   },

//   // Stripe configuration
//   stripe: {
//     publicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY,
//     secretKey: process.env.STRIPE_SECRET_KEY,
//     webhookSecret: process.env.STRIPE_WEBHOOK_SECRET,
//   },

//   // Email configuration
//   email: {
//     from: process.env.NEXT_PUBLIC_EMAIL_FROM || "noreply@landlordnoagent.com",
//     replyTo:
//       process.env.NEXT_PUBLIC_EMAIL_REPLY_TO || "support@landlordnoagent.com",
//     resendApiKey: process.env.RESEND_API_KEY,
//   },

//   // Environment
//   env: {
//     isProduction: isProduction(),
//     isDevelopment: isDevelopment(),
//     isTest: process.env.NODE_ENV === "test",
//   },

//   // Feature flags
//   features: {
//     emailValidation: true,
//     realTimeValidation: true,
//     adminTools: true,
//     // Client enhancements
//     kycStepper: false,
//     appFormRHF: false,
//     notifCenter: false,
//     savedSearches: false,
//     paymentsMvp: false,
//   },

//   // Environment validation status
//   envValidation,
// };

// // Database validation (async - will be validated when needed)
// let dbValidation: Awaited<ReturnType<typeof validateDatabaseSchema>> | null = null

// export async function getDatabaseValidation() {
//   if (!dbValidation) {
//     try {
//       dbValidation = await validateDatabaseSchema()
//     } catch (error) {
//       console.error('Database validation failed:', error)
//       dbValidation = {
//         isValid: false,
//         tables: [],
//         missingTables: [],
//         missingColumns: [],
//         missingPolicies: [],
//         errors: [error instanceof Error ? error.message : 'Unknown error']
//       }
//     }
//   }
//   return dbValidation
// }

// /**
//  * Get the full URL for a given path
//  * @param path - The path to append to the site URL
//  * @returns string - The full URL
//  */
// export function getFullUrl(path: string): string {
//   const baseUrl = config.site.url.replace(/\/$/, ""); // Remove trailing slash
//   const cleanPath = path.startsWith("/") ? path : `/${path}`;
//   return `${baseUrl}${cleanPath}`;
// }

// /**
//  * Get the auth page full URL
//  * @returns string - The auth page URL
//  */
// export function getAuthFullUrl(): string {
//   return getFullUrl(config.site.authUrl);
// }

// /**
//  * Get the dashboard URL for a specific role
//  * @param role - The user role
//  * @returns string - The dashboard URL
//  */
// export function getDashboardFullUrl(
//   role: "landlord" | "client" | "admin"
// ): string {
//   switch (role) {
//     case "landlord":
//       return getFullUrl(`${config.site.dashboardUrl}/landlord`);
//     case "client":
//       return getFullUrl(`${config.site.dashboardUrl}/client`);
//     case "admin":
//       return getFullUrl(config.site.adminUrl);
//     default:
//       return getAuthFullUrl();
//   }
// }


/**
 * Application configuration
 * Centralized configuration for environment variables and settings
 *
 * IMPORTANT: Make sure to create a .env.local file with all required environment variables.
 */

import { validateEnvironment, isDevelopment, isProduction } from './envValidation'
import { validateDatabaseSchema } from './dbValidation'

// 🧪 Validate environment variables once
const envValidation = validateEnvironment()

// Only throw in production if required env vars are missing
if (!envValidation.isValid && isProduction()) {
  throw new Error(
    `❌ Environment validation failed. Missing: ${envValidation.missing.join(', ')}`
  )
}

export const config = {
  site: {
    url:
      isDevelopment()
        ? 'http://localhost:3000'
        : import.meta.env.VITE_APP_URL ||
          'https://landlordnoagent.vercel.app',
    authUrl: '/auth',
    dashboardUrl: '/dashboard',
    adminUrl: '/admin/dashboard',
  },

  api: {
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5001/api',
    timeout: 10000,
    retries: 3,
  },

  stripe: {
    publicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
    secretKey: '', // Not available on frontend
    webhookSecret: '', // Not available on frontend
  },

  email: {
    from: 'noreply@landlordnoagent.com',
    replyTo: 'support@landlordnoagent.com',
    resendApiKey: '', // Not available on frontend
  },

  env: {
    isProduction: isProduction(),
    isDevelopment: isDevelopment(),
    isTest: import.meta.env.MODE === 'test',
  },

  features: {
    emailValidation: true,
    realTimeValidation: true,
    adminTools: true,
    kycStepper: true,   // MVP: stepped KYC in client profile
    appFormRHF: false,
    notifCenter: false,
    savedSearches: false,
    paymentsMvp: true, // MVP: payments (application fee, rent) enabled
  },

  envValidation,
}

// 🧭 Database validation (lazy)
let dbValidation: Awaited<ReturnType<typeof validateDatabaseSchema>> | null = null

export async function getDatabaseValidation() {
  if (!dbValidation) {
    try {
      dbValidation = await validateDatabaseSchema()
    } catch (error) {
      // Fallback validation result when DB check fails
      dbValidation = {
        isValid: false,
        collections: [],
        missingCollections: [],
        errors: [error instanceof Error ? error.message : 'Unknown error'],
      }
    }
  }
  return dbValidation
}

// ✅ Helper functions
export function getFullUrl(path: string): string {
  const baseUrl = config.site.url.replace(/\/$/, '')
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${cleanPath}`
}

export function getAuthFullUrl(): string {
  return getFullUrl(config.site.authUrl)
}

export function getDashboardFullUrl(
  role: 'landlord' | 'client' | 'admin'
): string {
  switch (role) {
    case 'landlord':
      return getFullUrl(`${config.site.dashboardUrl}/landlord`)
    case 'client':
      return getFullUrl(`${config.site.dashboardUrl}/client`)
    case 'admin':
      return getFullUrl(config.site.adminUrl)
    default:
      return getAuthFullUrl()
  }
}
